import React, { useEffect, useState } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
 
var CanvasJSChart = CanvasJSReact.CanvasJSChart;


const LigandCoreGraph = React.memo(function (props) {
  const [options, setOptions] = useState({});
  useEffect(() => {
    // Extract relevant props
    const { n, m, d_rec, K_1, a0, omega_LU} = props;
  

    const gamma = [1.7724538509055159, 1.0, 0.8862269254527579, 1.0, 1.329340388179137, 2.0, 3.323350970447843, 6.0, 11.63172839656745, 24.0, 52.34277778455352, 120.0, 287.88527781504433, 720.0, 1871.2543057977884, 5040.0, 14034.407293483413, 40320.0, 119292.46199460901, 362880.0, 1133278.3889487856, 3628800.0, 11899423.08396225, 39916800.0, 136843365.46556586, 479001600.0, 1710542068.3195734, 6227020800.0, 23092317922.31424, 87178291200.0, 334838609873.55646, 1307674368000.0, 5189998453040.126, 20922789888000.0, 85634974475162.08, 355687428096000.0, 1498612053315336.0, 6402373705728000.0, 2.772432298633372e+16, 1.21645100408832e+17, 5.4062429823350746e+17, 2.43290200817664e+18, 1.1082798113786907e+19, 5.109094217170944e+19, 2.382801594464185e+20, 1.1240007277776077e+21, 5.361303587544414e+21, 2.585201673888498e+22, 1.2599063430729378e+23, 6.204484017332394e+23, 3.086770540528698e+24, 1.5511210043330984e+25, 7.87126487834818e+25, 4.032914611266057e+26, 2.0858851927622676e+27, 1.0888869450418352e+28, 5.736184280096234e+28, 3.048883446117138e+29, 1.634812519827427e+30, 8.841761993739701e+30, 4.822696933490908e+31, 2.652528598121911e+32, 1.4709225647147272e+33, 8.222838654177924e+33, 4.633406078851391e+34, 2.6313083693369355e+35, 1.5058569756267023e+36, 8.683317618811887e+36, 5.044620868349452e+37, 2.952327990396042e+38, 1.740394199580561e+39, 1.0333147966386147e+40, 6.17839940851099e+40, 3.719933267899012e+41, 2.255115784106512e+42, 1.3763753091226346e+43, 8.456684190399417e+43, 5.230226174666011e+44, 3.2558234133037764e+45, 2.0397882081197442e+46, 1.2860502482549915e+47, 8.15915283247898e+47, 5.208503505432716e+48, 3.345252661316382e+49, 2.1615289547545774e+50, 1.4050061177528803e+51, 9.186498057706954e+51, 6.041526306337383e+52, 3.9961266551025234e+53, 2.6582715747884485e+54, 1.7782763615206234e+55, 1.1962222086548019e+56, 8.091157444918836e+56, 5.50262215981209e+57, 3.7623882118872593e+58, 2.5862324151116818e+59, 1.7871344006464477e+60, 1.2413915592536073e+61, 8.667601843135275e+61, 6.082818640342675e+62, 4.290462912351959e+63];
    // I started it from zero following this python code
    // from scipy.special import gamma
    // print('[', end='')
    // for i in range(100):
    //   print(gamma((1++i)/2), end=', ')
    // print(gamma(101/2), end=']')
    
    // Calculate Cn
    function calculate_Cn(n, d_core, d_rec, a0, r_ete) {
      const term1 = (n * Math.pow(2, 3 / 2)) / (8 * Math.pow(Math.PI, 3) * Math.pow(n, 2));
      const term2 = Math.pow((2 * Math.PI) / 3, 2);
      const term3 = Math.pow(d_core / d_rec, -2);
      const term4 = (0.5 * Math.pow(n, -3 / 2) * Math.pow((3 / (2 * Math.PI)), (3 / 2) * (n - 1)));
      const term5 = Math.pow((Math.pow(2, 7) / (3 * Math.pow(Math.PI, 2) * n)), n / 2);
      const term6 = (1 / Math.sqrt(Math.PI)) * gamma[n];  
      const term7 = Math.pow(a0 / d_rec, n);
      const term8 = Math.pow(d_rec, -3 * (n - 1));
      const term9 = Math.pow(d_core / d_rec - 1, 7 - 4 * n);
      const term10 = Math.pow((d_core - d_rec) / r_ete, 4 * n - 7);
      const term11 = Math.exp(-1.5 * n * Math.pow((d_core - d_rec) / r_ete, 2));

      const result =
        term1 * term2 * term3 * term4 * term5 * term6 * term7 * term8 * term9 * term10 * term11;

      return result;
    }

    const calculateKn = (K1, omegaLU, Cn, m, n) => {
      return (K1 ** n) * (omegaLU ** n) / (Cn * m ** n);
    };
    const numPoints = 10000;
const dRec =  d_rec// Define your value of d_rec here

const dCoreValues = Array.from({ length: numPoints }, (_, index) => 0.5 + (index / (numPoints - 1)) * (2 * dRec - 0.5));



    const KValues = dCoreValues.map((dCore) => {
      const rEte = Math.sqrt((3 * n) / (4 * n - 7)) * Math.abs(dCore - d_rec);
      const Cn = calculate_Cn(n, dCore, d_rec, a0, rEte);
      return calculateKn(K_1, omega_LU, Cn, m, n);
    });
    
    // // Define a range of k_on values
    // const k_off_values = [];
    // for (let i = -5; i <= 5; i += 0.0001) {
    //   k_off_values.push(Math.pow(10, i));
    // }

    //   const rb_values = k_off_values.map((k_off) => {
    //     return ((k_on * N) / (k_off + k_on * T)) * Math.sqrt(k_off / D);
    //   });

    const dataPoints = dCoreValues.map((dCore, i) => ({
      x: dCore,
      y: Math.log10(KValues[i]),
    }));

    const options = {
      axisX: {
        title: 'core size $d_{core} [nm]',
        minimum: -0.5 * d_rec,
        maximum: 2 * d_rec,
      },
      axisY: {
        title: 'log($K_N [M]$)',
        minimum: -50,
        maximum: 3,
      },
      data: [
        {
          type: 'line',
          dataPoints: dataPoints,
        },
      ],
      // Add a horizontal line at y = K_1
      axisYType: 'secondary',
      axisYIndex: 1,
    };
    
    // Add the horizontal line
    if (K_1) {
      options.axisYType = 'secondary';
      options.axisYIndex = 1;
      options.data.push({
        type: 'line',
        dataPoints: [{ x: -0.5 * d_rec, y: Math.log10(K_1) }, { x: 2 * d_rec, y: Math.log10(K_1) }],
        lineColor: 'red',
        lineDashType: 'dash',
        showInLegend: true,
        legendText: `$K_1$ = ${K_1} M`,
      });
    }
    
    setOptions(options);
    
  }, [props, props.n, props.m, props.d_rec, props.K_1, props.a0, props.omega_LU]);


  return (
    <div className="interactive-graph">
      <CanvasJSChart options={options} />
    </div>
  );
});

export default LigandCoreGraph;
